module.exports = __webpack_public_path__ + "img/realestate_menu_2.a5b844f3.png";